import fetch from '../fetch'
import { InsuranceCaseChangeType } from '../../models'

export type CaseReportPutInsuranceParams = {
  caseReportId: string
  insuranceParams: InsuranceCaseChangeType
}

/**
 * putInsurance
 * - sends CaseReportPutInsuranceParams data to the server via PUT /case-report/{id}/insurance
 */
export const putInsurance = (params: CaseReportPutInsuranceParams) => {
  const token = localStorage.getItem('token')
  return fetch({
    method: 'PUT',
    path: `api/v1/case-report/${params.caseReportId}/insurance`,
    data: params.insuranceParams,
    headers: {
      Authorization: token && `Bearer ${token}`,
    },
  })
}
